import React from "react";
import styles from "./ConstructionDetails.module.scss";
import ConstructionTable from "../table/ConstructionTable";
import type ConstructionDetailsProps from "./ConstructionDetailsProps";
import type {TableData} from "../table/ConstructionTableProps";
import ConstructionStatus from "../../../../types/ConstructionStatus";

const ConstructionDetails: React.FunctionComponent<ConstructionDetailsProps> = ({construction}) => {
  if (!construction) {
    return null;
  }

  function typedKeys<T extends object>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
  }

  const details = construction.constructionDetails;
  const keys = typedKeys(details);
  return (
    <div className={styles.constructionDetailsContainer}>
      {keys.map(key => (
        <ConstructionTable
          key={key}
          constructionId={construction.id}
          constructionElementsName={key}
          constructionPartItems={[details[key]] as TableData[]}
          isAccepted={construction.status === ConstructionStatus.Accepted}
        />
      ))}
    </div>
  );
};

export default ConstructionDetails;
